import { ClickAwayListener, Grow, Paper, Popper } from "@mui/material";
import { SelectInput } from "components/FormControls/Select/Select";
import { useMessage } from "hooks/intl";
import { useRef, useState } from "react";
import { parseMonthlyDays } from "../../../campaignHelpers";
import { Calendar } from "./Calendar";

interface Props {
  setFieldValue: (field: string, value: any) => void;
  dayOfMonth: number[] | "L"[];
}

export const MonthlySettings = ({ setFieldValue, dayOfMonth }: Props) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const anchorRef = useRef<HTMLInputElement | HTMLDivElement>(null);
  const { message } = useMessage();

  return (
    <ClickAwayListener
      onClickAway={(event) => {
        setIsCalendarOpen(false);
      }}
    >
      <div>
        <div ref={anchorRef}>
          <SelectInput
            items={[
              { id: "specificDays", label: message({ id: "specificDays" }) },
              { id: "L", label: message({ id: "lastDayOfTheMonth" }) },
            ]}
            isCustomSelect
            name="triggerStrategy.executionSchedule.dayOfMonth"
            label={message({ id: "repeatOn" })}
            onChange={(_e, val) => {
              if (val === "specificDays") {
                return setIsCalendarOpen(true);
              }
              setIsCalendarOpen(false);
              return setFieldValue(
                "triggerStrategy.executionSchedule.dayOfMonth",
                ["L"],
              );
            }}
            getOptionLabel={(value, items) => {
              if (!value) return "";

              if (value.includes("L")) {
                return message({ id: "lastDayOfTheMonth" });
              }

              return parseMonthlyDays({ days: value as [], message });
            }}
            helperText={message({ id: "monthlyTriggerDescription" })}
          />
        </div>
        <Popper
          open={isCalendarOpen}
          anchorEl={anchorRef.current}
          placement="bottom-start"
          transition
          disablePortal
          sx={{
            zIndex: 1302,
          }}
        >
          {({ TransitionProps, placement }) => (
            <Grow {...TransitionProps}>
              <Paper>
                <Calendar
                  cancel={() => setIsCalendarOpen(false)}
                  apply={(days: number[]) => {
                    setFieldValue(
                      "triggerStrategy.executionSchedule.dayOfMonth",
                      days,
                    );
                    setIsCalendarOpen(false);
                  }}
                  dayOfMonth={
                    dayOfMonth.filter(
                      (day) => typeof day === "number",
                    ) as number[]
                  }
                />
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </ClickAwayListener>
  );
};
